import React from 'react';
import CardInventory from '../../../../../utils/components/CardInventory/CardInventory';
import style from './InventoryLocationsMenu.module.css'
import { useHistory } from "react-router-dom";
import { Translate } from "../../../../../language";
import TitleSVG from "../../../../../utils/components/TitleSVG/TitleSVG";
import { WineryIcon, SubWineryIcon, EcoMasterIcon, EcoStoreIcon, OwnWarehouseIcon, Inventory } from '../../../../../assets/icons';

const InventoryLocationsMenu = () => {
  const history = useHistory();

  return (
    <div className={style.container}>
      <TitleSVG Icon={Inventory} titleHighlight={Translate('inventoryTitleHighlight', 'es')} title={Translate('inventoryTitle', 'es')} />

      <div className={style.container_options}>

        <CardInventory
          text={Translate('wineries', 'es')}
          onClick={() => { history.push('/Admin/Inventory/InventoryLocationsList/Winery') }}
          Icon={WineryIcon}
        />

        <CardInventory
          text={Translate('subWinery', 'es')}
          onClick={() => { history.push('/Admin/Inventory/InventoryLocationsList/SubWinery') }}
          Icon={SubWineryIcon}
        />

        <CardInventory
          text={Translate('representative', 'es')}
          onClick={() => { history.push('/Admin/Inventory/InventoryLocationsList/EcoMaster') }}
          Icon={EcoMasterIcon}
        />

        <CardInventory
          text={Translate('franchise', 'es')}
          onClick={() => { history.push('/Admin/Inventory/InventoryLocationsList/EcoTiendas') }}
          Icon={EcoStoreIcon}
        />

        <CardInventory
          text={Translate('ownStock', 'es')}
          onClick={() => { history.push('/Admin/Inventory/InventoryLocationsList/EcoCEO') }}
          Icon={OwnWarehouseIcon}
        />

        <CardInventory
          text={Translate('consolidatedInventory', 'es')}
          onClick={() => { history.push('/Admin/Inventory/ProductsConsolidation') }}
          Icon={Inventory}
        />

      </div>

    </div>
  )
}

export default InventoryLocationsMenu